<div class="card">
  <div class="card-body">
    <div
      class="d-flex justify-content-between align-content-center align-items-center"
    >
      <div>
        <a
          href="javascript:void(0);"
          class="btn btn-success mb-0"
          (click)="onAddRefuellingExpenseClick()"
        >
          Add Refuelling Expense
        </a>
      </div>
      <mat-form-field class="col-12 col-sm-6 col-md-4 p-0 m-0">
        <mat-label>Select Vehicle</mat-label>
        <mat-select
          [ngModel]="selectedCar"
          (selectionChange)="onCarSelect($event.value)"
        >
          <mat-option value="">Select a vehicle</mat-option>
          <mat-option *ngFor="let vehicle of userVehicles" [value]="vehicle">
            {{ vehicle.vehicleName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="d-flex justify-content-around align-content-center align-items-center"
    >
      <div class="pr-2 d-flex align-items-stretch w-full">
        <div class="card p-3 h-100 w-full">
          <h3>Total Fill-Ups</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.totalFillUpsInLtr }} L
          </h2>
        </div>
      </div>
      <div class="pr-2 d-flex align-items-stretch w-full">
        <div class="card p-3 h-100 w-full">
          <h3>Total Expenses on fuel</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.totalFuelExpense }}
          </h2>
        </div>
      </div>
      <div class="pr-2 d-flex align-items-stretch w-full">
        <div class="card p-3 h-100 w-full">
          <h3>Total Distance travalled</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.totalKmsTravelledWithoutApp }} Km
          </h2>
        </div>
      </div>
    </div>
    <div class="table-responsive mt-3">
      <table
        class="table table-centered datatable dt-responsive nowrap"
        style="border-collapse: collapse; border-spacing: 0; width: 100%"
      >
        <thead class="thead-light">
          <tr>
            <th>S.No.</th>
            <th>Date</th>
            <th>Fuel Type</th>
            <th>Odometer Reading</th>
            <th>Distance</th>
            <th>Total Fuel Expense</th>
            <th>Fuel in Liters</th>
            <th>Price/L</th>
            <!-- <th>Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of fuelExpenses; let i = index">
            <td>{{ i + 1 }}</td>
            <td>
              {{ item.fillUpDate | date : "dd/MM/yyyy" }}
            </td>
            <td>{{ item.fuelType }}</td>
            <td>{{ item.odometerReading }}</td>
            <td>
              {{ item.totalDistanceDrivenWithoutApp || "0" | number : "1.2-2" }}
            </td>
            <td>{{ item.totalFuelExpense | number : "1.2-2" }}</td>
            <td>{{ item.fuelInLitres | number : "1.2-2" }}</td>
            <td>{{ item.pricePerLiter | number : "1.2-2" }}</td>

            <!-- <td>
              <button
                mat-button
                (click)="onEditClick(item)"
                class="btn btn-primary"
              >
                Edit
              </button>
            </td> -->
          </tr>
        </tbody>
      </table>
      <mat-paginator
        (page)="pageEvent = getServerData($event)"
        [length]="totalRecords"
        [pageSize]="search.size"
        [pageSizeOptions]="[10, 20, 50, 100]"
        showFirstLastButtons
      ></mat-paginator>
    </div>
    <div class="text-center mt-5">
      <h1 class="mb-0 text-black font-weight-bold">Fuel Performance</h1>
      <p>Fuel Save mode vs Fuel burn mode</p>
    </div>
    <div class="col-12 row">
      <div class="card col-6 border-darken-1 p-2">
        <div class="d-flex justify-content-center align-items-center">
          <div id="chart">
            <apx-chart
              [series]="chartOptions.series"
              [chart]="chartOptions.chart"
              [labels]="chartOptions.labels"
              [responsive]="chartOptions.responsive"
            ></apx-chart>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card p-5">
          <h1>Average Mileage of Vehicle</h1>
          <h1 class="font-weight-bold text-success">
            {{ expenseMetricsData?.vhicleArAiMileage }} Km/l
          </h1>
        </div>
        <div class="card p-5">
          <h1>Mileage driving Fuelshine way</h1>
          <h1 class="font-weight-bold text-success">
            {{ expenseMetricsData?.mileageWithApp }} Km/l
          </h1>
        </div>
      </div>
    </div>
    <div class="card p-1 col-12"></div>
    <div class="row col-12 row-cols-4 g-3">
      <div class="pr-2 d-flex align-items-stretch">
        <div class="card p-3 h-100 w-full">
          <h3>Fill-Ups</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.totalFillUps }}
          </h2>
        </div>
      </div>
      <div class="pr-2 d-flex align-items-stretch">
        <div class="card p-3 h-100 w-full">
          <h3 class="mb-0">Mileage in Km/L</h3>
          <span>Based on fill-ups</span>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.mileageInKmWithoutApp }} Km/l
          </h2>
        </div>
      </div>
      <div class="pr-2 d-flex align-items-stretch">
        <div class="card p-3 h-100 w-full">
          <h3>Average Fuel Consumption</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.avgFuelConsumptionWithoutApp }}
          </h2>
        </div>
      </div>
      <div class="pr-2 d-flex align-items-stretch">
        <div class="card p-3 h-100 w-full">
          <h3>Average cost per Km</h3>
          <h2 class="text-success font-weight-bolder mt-2">
            {{ expenseMetricsData?.avgCostPerKmWithoutApp }}
          </h2>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addFuelExpenseModal role="document" let-modal="close">
  <div class="modal-header pb-0 mb-0">
    <h3 class="modal-title">Add Refuelling Expense</h3>
  </div>
  <div class="modal-body p-3">
    <div class="text-left px-5">
      <form
        (ngSubmit)="addRefuellingExpense()"
        [formGroup]="refuellingExpenseForm"
      >
        <div class="form-group">
          <label>Date </label>
          <input
            class="form-control"
            placeholder="Select fill up date"
            type="date"
            formControlName="fillUpDate"
          />
        </div>
        <div class="form-group">
          <label>Select Vehicle</label>
          <select
            class="form-control"
            formControlName="vehicle"
            (change)="onAddFuelExpenseVehicleChange()"
          >
            <option *ngFor="let vehicle of userVehicles" [value]="vehicle">
              {{ vehicle.vehicleName }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label>Odometer Reading</label>
          <input
            class="form-control"
            type="number"
            step="0.01"
            formControlName="odometerReading"
          />
        </div>
        <div class="form-group">
          <label>Total Fuel Expense</label>
          <input
            class="form-control"
            type="number"
            step="0.01"
            formControlName="totalFuelExpense"
          />
        </div>
        <div class="form-group">
          <label>Price per Liter</label>
          <input
            (input)="calculateFuelInLiters()"
            class="form-control"
            type="number"
            step="0.01"
            formControlName="pricePerLiter"
          />
        </div>
        <div class="form-group">
          <label>Fuel in Litres</label>
          <input
            disabled
            class="form-control"
            type="number"
            step="0.01"
            formControlName="fuelInLitres"
          />
        </div>
        <div class="form-group">
          <label>Fuel Type</label>
          <select class="form-control" formControlName="fuelType">
            <option value="DIESEL" selected>Diesel</option>
            <option value="PETROL">Petrol</option>
          </select>
        </div>

        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-danger ml-1 mr-2"
            (click)="modal('close click')"
          >
            Cancel
          </button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
